import { createContext, useContext, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { CheckCircle2, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { EnquiryForm } from "./EnquiryForm";

const Ctx = createContext(null);
export const useEnquiry = () => useContext(Ctx);

export const submitEnquiry = (payload) => api.post("/enquiries", payload);

export const EnquiryProvider = ({ children }) => {
  const [state, setState] = useState(null);
  const [done, setDone] = useState(false);
  const open = (kind, item) => { setDone(false); setState({ kind, item }); };
  const close = () => setState(null);

  return (
    <Ctx.Provider value={{ open }}>
      {children}
      <Dialog open={!!state} onOpenChange={(o) => !o && close()}>
        <DialogContent data-testid="enquiry-dialog" className="glass !bg-[var(--bg)] rounded-3xl max-w-md border-[var(--surface-border)]">
          {done ? (
            <div data-testid="enquiry-success" className="text-center py-6">
              <CheckCircle2 className="mx-auto text-[var(--pink)] drop-shadow-[0_0_12px_var(--glow-pink)]" size={56} />
              <h3 className="font-display text-3xl font-bold mt-4">Shukriya!</h3>
              <p className="text-[var(--muted)] mt-2 text-sm">Your request is received. Our team will contact you within 24 hours, in shaa Allah.</p>
              <button onClick={close} data-testid="enquiry-success-close" className="btn-neon mt-6">Done</button>
            </div>
          ) : (
            <>
              <DialogHeader>
                <DialogTitle className="font-display text-3xl">{state?.kind === "contact" ? "Get in touch" : "Reserve your seat"}</DialogTitle>
                <DialogDescription className="text-[var(--muted)]">
                  {state?.item ? <>For <b className="text-[var(--pink)]">{state.item}</b>. </> : null}Share your details and we'll guide you. No payment is taken right now.
                </DialogDescription>
              </DialogHeader>
              <EnquiryForm kind={state?.kind} item={state?.item} onDone={() => setDone(true)} />
            </>
          )}
        </DialogContent>
      </Dialog>
    </Ctx.Provider>
  );
};

export const SubmitButton = ({ loading, label }) => (
  <button type="submit" disabled={loading} data-testid="enquiry-submit-btn" className="btn-neon w-full justify-center disabled:opacity-70">
    {loading ? <Loader2 className="animate-spin" size={18} /> : null} {label}
  </button>
);

export const notifyError = (e) => {
  const d = e?.response?.data?.detail;
  toast.error(Array.isArray(d) ? "Please check your details (valid email, phone)." : "Something went wrong. Please try again.");
};
